<template>
  <div class="kl-table">
    <div class="table-wrapper" ref="tableWrapper">
      <el-table
          ref="KLTable"
          :data="data"
          :header-row-class-name="headerRowClassName"
          style="width: 100%"
          :row-key="rowKey"
          class="kl-table"
          :border="border"
          default-expand-all
          :height="Height"
          :show-summary="showSummary"
          :summary-method="summaryMethod"
          :tree-props="treeProps"
          @selection-change="handleSelectionChange"
          @row-click="handleRowClick"
      >
        <slot></slot>
        <div slot="empty">
          <slot name="empty">
            <div class="empty">
              <span>暂无数据</span>
            </div>
          </slot>
        </div>
      </el-table>
    </div>
    <div class="kl-pager" v-if="total > 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="listQuery.pageNo"
          :page-sizes="pageSizes"
          :page-size="listQuery.pageSize"
          :layout="layout"
          :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KL-Table',
  props: {
    headerRowClassName: {
      type: String,
      default: 'kl-table-header',
    },
    border: {
      type: Boolean,
      default: false,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function,
      default() {
        return () => {};
      },
    },
    treeProps: {
      type: Object,
      default() {
        return { children: 'children', hasChildren: 'hasChildren' };
      },
    },
    rowKey: {
      type: String,
      default: 'id',
    },
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    total: {
      type: Number,
      default: 0,
    },
    listQuery: {
      type: Object,
      default() {
        return {
          pageNo: 1,
          pageSize: 10,
        };
      },
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 30, 50, 100];
      },
    },
  },
  watch: {
  },
  data() {
    return {
      Height: '300px',
    };
  },
  mounted() {
    this.$nextTick(() => {
      // console.log(this.$refs.tableWrapper.clientHeight);
      this.Height = `${this.$refs.tableWrapper.clientHeight}px`;
    });
  },
  methods: {
    handleSizeChange(pageSize) {
      this.$emit('size-change', pageSize);
    },
    handleCurrentChange(pageNo) {
      this.$emit('current-change', pageNo);
    },
    handleSelectionChange(row) {
      this.$emit('selection-change', row);
    },
    handleRowClick(row, column, event) {
      this.$emit('row-click', row, this.data, column, event);
    },
  },
};
</script>

<style lang="scss" scoped>
  .kl-table {
    font-family: "PingFang-Medium";
    height: 100%;

    .empty {
      width: 400px;
      height: 310px;
      margin: 0 auto;

      img {
        width: 100%;
      }
    }

    .table-wrapper {
      /* position: absolute; */
      flex: 1;
      height: calc(100% - 50px);
      min-height:300px!important;
      ::v-deep.el-table {
        .kl-table-header {
          background: rgba(242, 243, 252, 1);

          th {
            background: rgba(242, 243, 252, 1);
          }
        }
      }
    }

    .kl-pager {
      /* position: absolute; */
      width: 100%;
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
